var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import Plugin, { POSITIONS, Util } from '../../plugin';
var BackSVG = '<svg width="32" height="40" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M11.237 14l6.382-6.381A.875.875 0 1016.38 6.38l-7 7a.875.875 0 000 1.238l7 7a.875.875 0 101.238-1.238L11.237 14z" fill="#FFF" fill-rule="evenodd"/></svg>';

var TopBackIcon = function (_Plugin) {
  _inherits(TopBackIcon, _Plugin);

  function TopBackIcon() {
    _classCallCheck(this, TopBackIcon);

    return _possibleConstructorReturn(this, (TopBackIcon.__proto__ || Object.getPrototypeOf(TopBackIcon)).apply(this, arguments));
  }

  _createClass(TopBackIcon, [{
    key: 'afterCreate',
    value: function afterCreate() {
      var _this2 = this;

      this.initIcons();
      this.onClick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        _this2.config.onClick(e);
      };

      this.bind(['click', 'touchend'], this.onClick);
    }
  }, {
    key: 'registerIcons',
    value: function registerIcons() {
      return {
        screenBack: { icon: BackSVG, class: 'xg-fullscreen-back' }
      };
    }
  }, {
    key: 'initIcons',
    value: function initIcons() {
      var icons = this.icons;

      this.appendChild(this.root, icons.screenBack);
    }
  }, {
    key: 'show',
    value: function show() {
      Util.addClass(this.root, 'show');
    }
  }, {
    key: 'hide',
    value: function hide() {
      Util.removeClass(this.root, 'show');
    }
  }, {
    key: 'render',
    value: function render() {
      return '<xg-icon class="xgplayer-back">\n    </xg-icon>';
    }
  }], [{
    key: 'pluginName',
    get: function get() {
      return 'topbackicon';
    }
  }, {
    key: 'defaultConfig',
    get: function get() {
      return {
        position: POSITIONS.ROOT_TOP,
        index: 0
      };
    }
  }]);

  return TopBackIcon;
}(Plugin);

export default TopBackIcon;